import * as React from "react";
const SvgHorizontalRule = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fill="var(--icon-primary)" d="M2 11h20v2H2z" /></svg>;
export default SvgHorizontalRule;